import LazyImages from './LazyImages';
import Filter from './Filter';
import Scroll from './Scroll';
import '../../styles/components/_loader.scss';
const SOFT_LOAD_REQUEST_TIMEOUT_MS = 30000;
const FADE_DURATION_MS = 200;
export default (() => {
    console.log('UNTUCKit : Module : SoftLoad : loaded');
    const loaders = () => document.querySelectorAll('.js-loader');
    const showLoad = () => {
        loaders().forEach((loader) => loader.classList.add('is-active'));
    };
    const hideLoad = () => {
        loaders().forEach((loader) => loader.classList.remove('is-active'));
    };
    const goToURL = (url) => {
        window.location.href = url;
    };
    const htmlNodes = (html) => {
        const template = document.createElement('template');
        template.innerHTML = html;
        return Array.from(template.content.childNodes);
    };
    const replaceWithHtml = (element, html) => {
        element.replaceWith(...htmlNodes(html));
    };
    const fadeOut = (element) => new Promise((resolve) => {
        const finish = () => {
            element.style.opacity = '0';
            element.style.display = 'none';
            resolve();
        };
        if (typeof element.animate !== 'function') {
            finish();
            return;
        }
        const animation = element.animate([{ opacity: getComputedStyle(element).opacity }, { opacity: 0 }], { duration: FADE_DURATION_MS, easing: 'ease', fill: 'forwards' });
        animation.onfinish = () => {
            animation.cancel();
            finish();
        };
    });
    const fetchText = async (url, timeoutMs) => {
        const controller = new AbortController();
        const timeout = timeoutMs
            ? window.setTimeout(() => controller.abort(), timeoutMs)
            : undefined;
        try {
            const response = await fetch(url, timeoutMs ? { signal: controller.signal } : undefined);
            if (!response.ok) {
                throw new Error('error');
            }
            return await response.text();
        }
        catch (error) {
            if (error instanceof Error && error.message === 'error') {
                throw error;
            }
            if (error instanceof DOMException && error.name === 'AbortError') {
                throw new Error('timeout', { cause: error });
            }
            throw new Error('error', { cause: error });
        }
        finally {
            if (timeout) {
                window.clearTimeout(timeout);
            }
        }
    };
    const scrollToHash = (hash) => {
        let scrollTo = 0;
        if (hash !== '') {
            const target = document.getElementById(`${hash}_h`);
            if (target) {
                scrollTo = target.getBoundingClientRect().top + window.scrollY;
            }
        }
        const newUrl = hash === '' ? window.location.href.split('#')[0] : `#${hash}`;
        Scroll.animate(scrollTo);
        if (newUrl) {
            history.replaceState(null, '', newUrl);
        }
    };
    const getCollection = async (url, skipHistory) => {
        const targets = Array.from(document.querySelectorAll('[data-ajax-target]'));
        if (targets.length === 0) {
            return;
        }
        const getUrl = `${url}?view=softLoad`;
        await Promise.all(targets.map((target) => (target instanceof HTMLElement ? fadeOut(target) : Promise.resolve())));
        showLoad();
        try {
            const html = await fetchText(getUrl, SOFT_LOAD_REQUEST_TIMEOUT_MS);
            hideLoad();
            targets.forEach((target) => replaceWithHtml(target, html));
            Filter.init();
            const title = document.querySelector('[data-doc-title]')?.getAttribute('data-doc-title') ?? '';
            document.title = title;
            LazyImages.update();
            if (!skipHistory) {
                if (url) {
                    history.pushState({ title }, title, url);
                }
                scrollToHash('');
            }
            LazyImages.update();
        }
        catch (error) {
            const textStatus = error instanceof Error ? error.message : 'error';
            console.log('UNTUCKit : Module : SoftLoad : getCollection failed', textStatus);
            hideLoad();
            goToURL(url);
        }
    };
    const getInStore = async () => {
        const handle = document.body.dataset.collection;
        const getUrl = `/collections/${handle}?view=softloadinstore`;
        console.time('SoftLoad_getInStore');
        try {
            const response = await fetch(getUrl);
            if (!response.ok) {
                throw new Error('error');
            }
            const html = await response.text();
            document.querySelectorAll('.instore_product_types').forEach((section) => {
                replaceWithHtml(section, html);
            });
            LazyImages.update();
            console.timeEnd('SoftLoad_getInStore');
        }
        catch {
            console.log('UNTUCKit : Module : SoftLoad : getInStore Failed');
        }
    };
    const getGrouped = async () => {
        const handle = document.body.dataset.collection;
        const getUrl = `/collections/${handle}?view=softloadgroup`;
        console.time('SoftLoad_getGrouped');
        try {
            const response = await fetch(getUrl);
            if (!response.ok) {
                throw new Error('error');
            }
            const html = await response.text();
            document.querySelectorAll('.grouped_products').forEach((section) => {
                replaceWithHtml(section, html);
            });
            LazyImages.update();
            console.timeEnd('SoftLoad_getGrouped');
        }
        catch {
            console.log('UNTUCKit : Module : SoftLoad : getGrouped Failed');
        }
    };
    const onPopState = (event) => {
        const url = window.location.pathname;
        if (event.state !== null && url.indexOf('collection') !== -1) {
            void getCollection(url, true);
        }
    };
    const onInStoreLoad = () => {
        console.log('UNTUCKit : Module : SoftLoad : inStoreAsync');
        void getInStore();
    };
    const onGroupLoad = () => {
        console.log('UNTUCKit : Module : SoftLoad : groupAsync');
        void getGrouped();
    };
    const bindUIActions = () => {
        window.removeEventListener('popstate', onPopState);
        window.addEventListener('popstate', onPopState);
    };
    function inStoreAsync() {
        window.removeEventListener('load', onInStoreLoad);
        window.addEventListener('load', onInStoreLoad);
    }
    function groupAsync() {
        window.removeEventListener('load', onGroupLoad);
        window.addEventListener('load', onGroupLoad);
    }
    function init() {
        console.log('UNTUCKit : Module : SoftLoad : init');
        bindUIActions();
        if (window.groupAsync) {
            groupAsync();
        }
    }
    return { init, inStoreAsync };
})();
